module.exports = __webpack_public_path__ + "img/qianzixq_img.cdbb9507.png";